export default "__VITE_ASSET__CJyMpF2B__"